import { Component } from '@angular/core';

@Component({
    selector: 'app-loading-screen',
    imports: [],
    templateUrl: './loading-screen.component.html',
    styleUrl: './loading-screen.component.scss'
})
export class LoadingScreenComponent {
    
}
